export const SplitLine = ({ color = '#DFE3E8', height = '1PX' }) => (
  <section
    style={{
      background: color,
      width: '100%',
      height,
    }}
  />
);
